import { createAction } from "@reduxjs/toolkit";
import {
  deleteUserFromBlockListActionTypes,
  getUserBlockListActionTypes,
} from "./actionTypes";

export const getUserBlockList = createAction(
  getUserBlockListActionTypes.request,
  (payload) => ({
    payload,
  }),
);

export const getUserBlockListSuccess = createAction(
  getUserBlockListActionTypes.success,
  (payload) => ({
    payload,
  }),
);

export const getUserBlockListFailure = createAction(
  getUserBlockListActionTypes.failure,
  (error) => ({
    payload: error,
  }),
);

export const deleteUserFromBlockListSuccess = createAction(
  deleteUserFromBlockListActionTypes.success,
  (error) => ({
    payload: error,
  }),
);

export const deleteUserFromBlockListReset = createAction(
  deleteUserFromBlockListActionTypes.reset,
);
